export default __webpack_public_path__ + "static/media/bar-main_pc.167bdbbc.png";